'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../../../../common/common.module');

require('../../../feiseanna/one');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

require('../../../../router-history');

var _schools = require('ifeis-isomorphic/lib/redux/actions/schools');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _numberFormatting = require('../../../../common/utils/number-formatting');

var _immutable = require('immutable');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchoolResultsForTeacherController = function () {
  function SchoolResultsForTeacherController($ngRedux, $stateParams, $state, feis) {
    var _this = this;

    _classCallCheck(this, SchoolResultsForTeacherController);

    this.feis = feis;
    this._ = {
      $state: $state
    };
    this.loadingComments = true;
    $ngRedux.dispatch((0, _schools.getStudentsResults)($stateParams.sid, $stateParams.id)).finally(function () {
      return _this.loadingComments = false;
    });

    $ngRedux.connect((0, _mapStateToController2.default)($stateParams.sid, $stateParams.id))(this);
  }

  _createClass(SchoolResultsForTeacherController, [{
    key: 'goIndividualResults',
    value: function goIndividualResults(pid) {
      this._.$state.go('feiseanna.one.resultsForPerson', { id: this.feis.id, slug: this.feis.slug, pid: pid });
    }
  }, {
    key: 'getOrdinalForPlacement',
    value: function getOrdinalForPlacement(number) {
      return (0, _numberFormatting.getOrdinal)(number);
    }
  }, {
    key: 'isResultsLoading',
    value: function isResultsLoading() {
      return this.loading || this.loadingComments;
    }
  }, {
    key: 'getDressCheckForAdjudicator',
    value: function getDressCheckForAdjudicator(adj, dressChecks) {
      return (dressChecks.find(function (dress) {
        return dress.get('adj_id') === adj.get('id');
      }) || (0, _immutable.Map)()).get('dressCheck') || false;
    }
  }, {
    key: 'getCommentForAdjudicator',
    value: function getCommentForAdjudicator(adj, comments) {
      return (comments.find(function (comment) {
        return comment.get('adj_id') === adj.get('id');
      }) || (0, _immutable.Map)()).get('text') || undefined;
    }
  }]);

  return SchoolResultsForTeacherController;
}();

angular.module('ifeis.routes.feiseanna.one.results-for-teacher', ['ngMaterial', 'ui.router', _ngRedux2.default, 'ifeis.routes.feiseanna.one']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.results-for-teacher', {
    url: '/school/:sid/feisresults',
    template: require('./tpl.html'),
    controller: SchoolResultsForTeacherController,
    controllerAs: 'schoolResultsForTeacher',
    ncyBreadcrumb: {
      label: 'Results For School',
      parent: 'feiseanna.one.landing-page'
    }
  });
}).controller('SchoolResultsForTeacherController', SchoolResultsForTeacherController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/school-results-for-teachers/index.js
// module id = 597
// module chunks = 0